import React, { useState, useEffect, useContext } from 'react';

import {
    makeStyles,
    Divider
} from '@material-ui/core'; 
import {
    PortalContext, 
    HomeWidgetError,
    Dialog,
    menuHelper,
    esGestiona,
    api,
} from '@portal/arq-portal-core';

import { UltimasVisitas } from './UltmasVisitas';
import { EnlacesFavoritos } from './EnlacesFavoritos';
import { CabeceraSeccion} from './CabeceraSeccion';
import useFavoritos from '../hooks/useFavoritos';
import { generadorIdAleatorio } from '../utils/generador';
import { FavoritosContext } from '../context/FavoritosContext';
import { EnlacesPersonalesSeccion } from './EnlacesPersonalesSeccion';

import useSWR from "swr";
const useStyles = makeStyles(() => ({
    raiz: {
        backgroundColor: '#fff',
        width: '100%',
        display: 'flex',
        justifyContent : 'flex-start',
        paddingTop: '10px',
        '@media screen and (max-width: 1200px)': {
            display: 'block',
        }
    },
    favoritos: {
        width: '80%',
        padding: '16px',
        backgroundColor: '#fff',
        '@media screen and (max-width: 1200px)': {
            width: '100% !important',
            boxSizing: 'border-box',
        }
    },
    ultimasVisitas: {
        width: '20%',
        padding: '16px',
        backgroundColor: '#fff',
        '& hr:first-of-type ': {
            marginBottom: '1rem',
        },
        '@media screen and (max-width: 1200px)': {
            width: '100% !important',
            boxSizing: 'border-box',
        }
    }, 
    divisorFavoritos : {
        height: '473px', 
        alignSelf: 'center', 
        width:'2px', 
        color: '#888',
        '@media screen and (max-width: 1200px)': {
            height: "2px",
            width: "100%"
        }
    }, 
    contenerdor: {
        display: 'block',
        width: '100%',
        float: 'left',
    },
    enlacesExternosWrapper:{
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        width: '50%',
        padding: '16px',
        backgroundColor: '#fff',
        // '& hr:first-of-type ': {
        //     marginBottom: '1rem',
        // },
        '@media screen and (max-width: 1200px)': {
            width: '100% !important',
            boxSizing: 'border-box',
        }

    },
    enlacesUltimasVisitasWrapper:{
        width: '50%',
        padding: '16px',
        backgroundColor: '#fff',
      
        '@media screen and (max-width: 1200px)': {
            width: '100% !important',
            boxSizing: 'border-box',
        }
    },
    enlacesUltimasVisitas:{
        // height: '300px',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column'
    }

}));



export const Favoritos = (props:any) => {
    const actualizarIdClick = props?.actualizarIdClick ? props.actualizarIdClick: undefined;
    const [favoritosID] = useState<string>("fav_" + Math.floor(Math.random() * 101).toString());
    const clases = useStyles();
    const { user } = useContext(PortalContext);
    const favoritosSWRKey = "favoritos";
    const { data, error } = useFavoritos([favoritosSWRKey, user?.id]);
    const { menuIds } = useContext(PortalContext);
    const [enlacesFavoritos, setEnlacesFavoritos] = useState<any[]>();
    const [enlacesPersonales, setEnlacesPersonales] = useState<any[]>();
    const [enlacesFavOriginal, setEnlacesFavOriginal] = useState<any[]>();
    const [enlaceClick, setEnlaceClick] = useState(false);
    const [hasFavError, setHasFavError] = useState({
        hasError : false,
        errorMessage : ""
    })
    const [menuReducido,setMenuReducido] = React.useState<boolean>(esGestiona()?false:true);

    if(!esGestiona()){
        const options2 = { focusThrottleInterval: 1000 * 3600 * 4, revalidateOnMount: true, revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false, dedupingInterval: 1000 * 3600 * 4 };
        const { data:dataReducido } = useSWR(["menureducido", user?.id], () => api.post("/be/menureducido", { Entrada: {} }), options2);
      
        React.useEffect(() => {
            console.log('actualizado menu Reducido:', dataReducido?.Salida.MenuReducido)
              if(dataReducido && dataReducido.Salida && dataReducido.Salida.MenuReducido != undefined){
                setMenuReducido(dataReducido?.Salida.MenuReducido);
                // setShowCompleteVersion(!dataReducido?.Salida.MenuReducido) ;
              }
          }, [dataReducido]);
    }

    
    const guardarAccesoRapido = () => {
        setHasFavError({
            hasError : false,
            errorMessage : ""
        });
    };

    const checkError = (result:any) =>{
        if (result.Retorno?.Codigo === 1) {
            
            setHasFavError( prevValue => {
                return {
                    ...prevValue, 
                    hasError : true,
                    errorMessage : result.Retorno.Descripcion
                }
            });
        }
    }

    useEffect(() => {
        if (data) {
            if (data.Salida && data.Salida.Favoritos && data.Salida.Favoritos.length > 0) {
                const favoritos: any[] = [];
                setEnlacesFavOriginal(data.Salida.Favoritos);
                data.Salida.Favoritos.forEach((element: any) => {
                    let menuOption = menuIds?.get(element.Url);
                    if(menuOption){
                        const TargetUrl = menuOption.url;
                        let urlSplited = TargetUrl ? TargetUrl.split('/') : [];
                        let titulo = urlSplited.length >= 1 ? urlSplited[1] : menuOption.titulo;
                        if(esGestiona()){
                            titulo = titulo.toLowerCase().replace('spu','');
                            titulo = titulo.replace('sbi','');
                            titulo = titulo.replace('sco','');
                        }
                        const menuExistente = favoritos.find((el: any) => el.titulo === titulo);
                        const nombre = menuHelper.getFavName(menuIds, menuOption.id as string);
                        if (menuExistente) {
                            menuExistente.enlaces.push({...element, nombre, TargetUrl});
                        } else {
                            favoritos.push({
                                titulo: titulo,
                                id: generadorIdAleatorio(),
                                enlaces: [{...element, nombre, TargetUrl}]
                            });
                        }
                    }
                });
                setEnlacesFavoritos(favoritos);
            } else {
                setEnlacesFavoritos([]);
            }
            
            if (data.Salida && data.Salida.Personales && data.Salida.Personales.length > 0) {
                setEnlacesPersonales(data.Salida.Personales);
            } else {
                setEnlacesPersonales([]);
            }
           if(data?.favoritosID == favoritosID) checkError(data);
        }else{
            setEnlacesFavOriginal([]);
            setEnlacesFavoritos([]);
            setEnlacesPersonales([]);
        }
    }, [data]);

    useEffect(() => {
        if (enlaceClick) {
            if(props.onClose) props.onClose();
            setEnlaceClick(false);
        }
    }, [enlaceClick]);

    return (
        <FavoritosContext.Provider value={{enlaceClick, setEnlaceClick, favoritosSWRKey, favoritosID, actualizarIdClick}} >
            <div className={clases.raiz}>
                { hasFavError.hasError &&
                <Dialog
                title="¡Atención!"
                open={hasFavError.hasError}
                manejarCierre={guardarAccesoRapido}
                guardar={guardarAccesoRapido}
                tituloAceptar="Aceptar"
                >
                <p>{hasFavError.errorMessage}</p>
                </Dialog>
                }
                { menuReducido && (enlacesPersonales !== undefined && !error) && 
                 <React.Fragment>
                    <div className={clases.enlacesExternosWrapper}>
                        <EnlacesPersonalesSeccion personales={enlacesPersonales} />
                    </div>
                    <Divider orientation="vertical"  flexItem className={clases.divisorFavoritos}></Divider>
                    <div className={clases.enlacesUltimasVisitasWrapper}>
                        <CabeceraSeccion titulo="Últimos visitados" />
                        <div className={clases.enlacesUltimasVisitas} >
                            <UltimasVisitas favs={enlacesFavOriginal}/>
                        </div>   
                    </div>
                </React.Fragment>
                }
                { !menuReducido && (enlacesPersonales !== undefined && enlacesFavoritos !== undefined && !error) &&
                    <React.Fragment>
                        <Dialog
                            title="¡Atención!"
                            open={hasFavError.hasError}
                            manejarCierre={guardarAccesoRapido}
                            guardar={guardarAccesoRapido}
                            tituloAceptar="Aceptar"
                        >
                        <p>{hasFavError.errorMessage}</p>
                        </Dialog>
                        <div className={clases.favoritos}>
                            <CabeceraSeccion titulo= "Enlaces favoritos" colorDivisor="#DC0028" colorTitulo="#DC0028" />
                            <EnlacesFavoritos favoritos={enlacesFavoritos} personales={enlacesPersonales} />
                        </div>
                        <Divider orientation="vertical"  flexItem className={clases.divisorFavoritos}></Divider>
                        <div className={clases.ultimasVisitas}>
                            <CabeceraSeccion titulo="Últimos visitados" />
                            <UltimasVisitas />
                        </div>
                    </React.Fragment>
                } 
                {error && <div className={clases.contenerdor}><HomeWidgetError error={error.mensaje ?? error} /></div>}
                
               
            </div>
        </FavoritosContext.Provider>
        

    )
}

